import HotCar from './HotCar';
export default HotCar;